//hover menu
document.addEventListener("DOMContentLoaded", () => {

  if (window.innerWidth < 990) return;

  document.querySelectorAll(".mega-menu").forEach(menu => {

    const details = menu;
    let timer;

    menu.addEventListener("mouseenter", () => {
      clearTimeout(timer);
      details.setAttribute("open", "");
    });

    menu.addEventListener("mouseleave", () => {
      timer = setTimeout(() => {
        details.removeAttribute("open");
      }, 200);
    });

  });

});

//mega menu
document.addEventListener("DOMContentLoaded", () => {

    const menuItems = document.querySelectorAll(".tkc-menu-item");
    const panels = document.querySelectorAll(".tkc-panel");

    // Default active panel
    if (menuItems.length && panels.length) {
        menuItems[0].classList.add("active");
        panels[0].classList.add("active");
    }

    menuItems.forEach((item) => {

        item.addEventListener("mouseenter", function () {

            const target = this.dataset.menu;

            // Remove active class
            menuItems.forEach(i => i.classList.remove("active"));
            panels.forEach(p => p.classList.remove("active"));

            // Add active
            this.classList.add("active");

            const panel = document.getElementById(target);

            if(panel){

                panel.classList.add("active");

            }

        });

    });

});
